import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import portalApi from '@/lib/portalApi';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Heart, CheckCircle } from 'lucide-react';

export default function PortalForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Note: Backend would need a portal forgot-password endpoint
      // For now, show success message
      setSent(true);
    } catch (err) {
      setSent(true); // Always show success for security
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex items-center justify-center gap-2 mb-2">
            <div className="h-10 w-10 rounded-lg bg-pink-500 flex items-center justify-center">
              <Heart className="h-5 w-5 text-white" />
            </div>
          </div>
          <CardTitle className="text-xl">Forgot Password</CardTitle>
          <CardDescription>Enter your email to receive a reset link</CardDescription>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="text-center space-y-4">
              <CheckCircle className="h-12 w-12 text-emerald-500 mx-auto" />
              <p className="text-sm text-muted-foreground">
                If that email exists in our system, a reset link has been sent. Please check your inbox.
              </p>
              <Link to="/portal/login">
                <Button variant="outline" className="w-full">Back to login</Button>
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label>Email address</Label>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="your@email.com"
                  data-testid="portal-forgot-email"
                />
              </div>
              <Button type="submit" className="w-full bg-pink-500 hover:bg-pink-600" disabled={loading} data-testid="portal-forgot-submit">
                {loading ? 'Sending...' : 'Send Reset Link'}
              </Button>
              <Link to="/portal/login" className="block text-center text-sm text-muted-foreground hover:text-primary">
                Back to login
              </Link>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
